import Cache from 'services/utils/Cache'
import jsonCache from 'services/utils/jsonCache'

export const JSONCache = jsonCache()(Cache)
